<template>
  <!-- 时间线-组件 -->
  <el-timeline class="content-block">
    <el-timeline-item v-for="(item, index) in listData" :key="index">
      <h6>{{ item.content }}</h6>
      <p>{{ item.creator }} 提交于 {{ item.createTime }}</p>
    </el-timeline-item>
  </el-timeline>
</template>

<script>
export default {
  name: 'TimeLine',
  props: {
    // 列表信息
    listData: {
      type: Array,
      default: () => [],
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>

